webpackJsonp([9],{

/***/ "2lO7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5jCd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("71be94aa", content, true, {});

/***/ }),

/***/ "5jCd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "#judge{width:100%;height:100%;position:fixed;left:0;top:0;background:#fff}", "", {"version":3,"sources":["E:/websites/lvjinhui/Ljh_OS/PC端/ljh_OS_Online_fix_v2.0(1&2融合版)-使用/src/components/isPcOrPhone/isPcOrPhone.vue"],"names":[],"mappings":"AACA,OACE,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,OAAQ,AACR,MAAO,AACP,eAAoB,CACrB","file":"isPcOrPhone.vue","sourcesContent":["\n#judge {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: fixed;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tbackground: #ffffff;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "ch93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
		methods: {
				//判断是手机还是pc
				browserRedirect: function browserRedirect() {
						var sUserAgent = navigator.userAgent.toLowerCase();
						var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
						var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
						var bIsMidp = sUserAgent.match(/midp/i) == "midp";
						var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
						var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
						var bIsAndroid = sUserAgent.match(/android/i) == "android";
						var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
						var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
						if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
								this.$router.push({ path: '/login' });
						} else {
								window.location.href = 'http://m.lvjinhui.cn';
						}
						this.$router.push({ path: '/login' });
				}
		},
		created: function created() {
				this.browserRedirect();
		}
});

/***/ }),

/***/ "eWY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"judge"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sDBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_isPcOrPhone_vue__ = __webpack_require__("ch93");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff06c30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_isPcOrPhone_vue__ = __webpack_require__("eWY/");
function injectStyle (ssrContext) {
  __webpack_require__("2lO7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_isPcOrPhone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff06c30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_isPcOrPhone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/9.5e1184e5a5c18af23db4.js